export type CatalogPlan = {
  code: string;
  name: string;
  priceCents: number;
  projects: number;
  widgetsPerProject: number;
  highlight: boolean;
  tagline: string;
  features: string[];
};

export const FREE_LIMITS = {
  trialDays: 7,
  projects: 1,
  widgetsPerProject: 1,
};

export const CATALOG_PLANS: CatalogPlan[] = [
  {
    code: "pro_monthly_br",
    name: "Pro",
    priceCents: 9900,
    projects: 3,
    widgetsPerProject: 3,
    highlight: false,
    tagline: "Para times que começam a escalar o suporte.",
    features: [
      "3 projetos por workspace",
      "Até 3 widgets por projeto",
      "Base de conhecimento por projeto",
      "Widget embutível no Oracle APEX",
      "Analytics, avaliações e lacunas",
    ],
  },
  {
    code: "business_monthly_br",
    name: "Business",
    priceCents: 14900,
    projects: 3,
    widgetsPerProject: 4,
    highlight: true,
    tagline: "Mais instalações para ambientes do mesmo produto.",
    features: [
      "3 projetos por workspace",
      "Até 4 widgets por projeto",
      "Base de conhecimento por projeto",
      "Widget embutível no Oracle APEX",
      "Analytics, avaliações e lacunas",
    ],
  },
  {
    code: "scale_monthly_br",
    name: "Scale",
    priceCents: 19900,
    projects: 6,
    widgetsPerProject: 4,
    highlight: false,
    tagline: "Para operações com mais produtos e equipes.",
    features: [
      "6 projetos por workspace",
      "Até 4 widgets por projeto",
      "Base de conhecimento por projeto",
      "Widget embutível no Oracle APEX",
      "Analytics, avaliações e lacunas",
    ],
  },
];

export function planLookupKey(code: string): string {
  const known: Record<string, string> = {
    pro_monthly_br: "nexo_pro_monthly",
    business_monthly_br: "nexo_business_monthly",
    scale_monthly_br: "nexo_scale_monthly",
  };
  return known[code] ?? `nexo_${code}`;
}

export function catalogPlanByCode(
  code: string | null | undefined,
): CatalogPlan | undefined {
  return CATALOG_PLANS.find((plan) => plan.code === code);
}